import React, { useState } from "react";

const ResourcesScreen = () => {
  const [activeTab, setActiveTab] = useState("Frequently Asked Questions"); // Default tab

  // Data for each tab
  const tabs = [
    "VIHA",
    "Island Health",
    "Health Canada",
    "Frequently Asked Questions",
    "Contact Us",
  ];

  const faqs = [
    {
      question: "How do I add someone to my account?",
      answer:
        "Do I need to pay to Instapay even when there is no transaction going on in my business? No, you do not need to pay Instapay where there is no transaction happening. With one of the lowest transaction charges in the industry, pay only when you get paid!",
    },
    {
      question: "How do I pay my Care Provider?",
      answer: "You can pay your Care Provider via our secure payment gateway.",
    },
    {
      question: "What is a Care Provider?",
      answer:
        "A Care Provider is a professional who provides healthcare or assistance to those in need.",
    },
    {
      question: "Who is iCare Village?",
      answer:
        "iCare Village is a platform connecting individuals with caregivers and healthcare providers.",
    },
  ];

  return (
    <>
      <header className="titleContainer">
        <h1>Resources</h1>
      </header>
      <div className="resources-container">
        <div className="resources-tab-bar">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`resources-tab-item ${
                activeTab === tab ? "resources-active-tab" : ""
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="resources-tab-content">
          <div className="resources-tab-title">
            <h2>{activeTab}</h2>
          </div>
          <div className="resources-faqs-section">
            {faqs.map((faq, index) => (
              <details key={index} className="resources-faq-item">
                <summary>{faq.question}</summary>
                <p>{faq.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourcesScreen;
